// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"425":"3ef30fc8","514":"ab666260","581":"059be49d","977":"dc495fcd"}[chunkId] + ".chunk.js";
};